import {globals} from '@extensions/globals-base'
import {useEffect} from 'react'
import {useForceUpdate} from './hooks'

export const useCompanyUpdateEffect = (onCompanyChange?: () => void): void => {
  const upd = useForceUpdate()
  useEffect(() => {
    const listenerId = globals.onCompanyChange(() => {
      upd()
      onCompanyChange?.()
    })
    return () => {
      globals.removeCompanyListener(listenerId)
    }
  }, [])
}
